import {
	DefaultMenuItem,
	GetContextMenuItemsParams,
	MenuItemDef,
} from "ag-grid-community";
import React from "react";

export const useGetMenuOptions = ({
	rows,
	selectedRowId,
	setSelectedRowId,
	showContextMenu,
}: {
	rows: any[];
	selectedRowId: string;
	setSelectedRowId: (id: string) => void;
	showContextMenu: (event: any, data: any, context: string) => void;
}) => {
	const getContextMenuItems = React.useCallback(
		(params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
			const data = params.node?.data;
			showContextMenu(event as any, data, "moldContext");
			if (selectedRowId) {
				const previousRow = document.querySelector(
					`.ag-row[row-id="${selectedRowId}"]`,
				);
				if (previousRow) previousRow.classList.remove("custom-selected");
			}
			if (params && params.node && params.node.id) {
				setSelectedRowId(params.node.id);
				const currentRow = document.querySelector(
					`.ag-row[row-id="${params.node.id}"]`,
				);
				if (currentRow) currentRow.classList.add("custom-selected");
			}
			return [];
		},
		[rows],
	);
	return getContextMenuItems;
};
